import classNames from 'classnames/bind';
import ReactQuill, { Quill } from 'react-quill';
import { memo, useCallback, useEffect, useRef, useState } from 'react';
import ImageResize from 'quill-image-resize-module-react';
import { ModeTextEditorEnum, ThemeTextEditorEnum } from '~/utils/enum';
import styles from './TextEditor.module.scss';
import './TextEditor.scss';
import 'react-quill/dist/quill.snow.css';
import 'react-quill/dist/quill.bubble.css';
import { DEFAULT_VALUE_EMPTY_RICH_EDITOR, toolbarOptionsRichEditor } from '~/utils/constants';

Quill.register('modules/imageResize', ImageResize);

type Props = {
  placeholder?: string;
  theme?: ThemeTextEditorEnum;
  mode: ModeTextEditorEnum;
  value?: string;
  onChange?: (value: string) => void;
  className?: string;
};

const cx = classNames.bind(styles);

const TextEditor = (props: Props) => {
  //#region Destructuring Props
  const { placeholder, theme = ThemeTextEditorEnum.SNOW, mode, value = '', onChange, className } = props;
  //#endregion Destructuring Props

  //#region Declare Hook
  const reactQuillRef = useRef<ReactQuill>(null);
  //#endregion Declare Hook

  //#region Selector
  //#endregion Selector

  //#region Declare State
  const [textEditorValue, setTextEditorValue] = useState<string>('');
  const modules = {
    toolbar: {
      container: toolbarOptionsRichEditor,
    },
    imageResize: {
      parchment: Quill.import('parchment'),
      modules: ['Resize', 'DisplaySize'],
    },
  };
  //#endregion Declare State

  //#region Implement Hook
  useEffect(() => {
    setTextEditorValue(value);
  }, [value]);
  //#endregion Implement Hook

  //#region Handle Function
  const handleChange = useCallback(
    (content: string) => {
      if (content === DEFAULT_VALUE_EMPTY_RICH_EDITOR) {
        onChange && onChange('');
        return setTextEditorValue('');
      }
      setTextEditorValue(content);
      onChange && onChange(content);
    },
    [onChange]
  );
  //#endregion Handle Function

  return (
    <div id='textEditorComponent'>
      {theme === ThemeTextEditorEnum.SNOW && (
        <div className={cx('quillEditorGroup', className)} data-text-editor='editor'>
          <ReactQuill
            ref={reactQuillRef}
            theme={ThemeTextEditorEnum.SNOW}
            readOnly={mode === ModeTextEditorEnum.VIEW}
            modules={modules}
            value={textEditorValue}
            onChange={handleChange}
            placeholder={placeholder}
            className={cx('quill')}
            bounds={'[data-text-editor="editor"]'}
          />
        </div>
      )}

      {theme === ThemeTextEditorEnum.BUBBLE && (
        <div className={cx('bubbleEditor', className)}>
          <ReactQuill ref={reactQuillRef} theme={ThemeTextEditorEnum.BUBBLE} readOnly={true} value={value} />
        </div>
      )}
    </div>
  );
};

export default memo(TextEditor);
